module.exports = __webpack_public_path__ + "img/3.a87be2e8.png";